import Engagement from './Engagement'
import EventDetail from './EventDetail'
import MessageDetail from './MessageDetail'

export default [
	{
		path: 'engagement',
		props: true,
		component: Engagement
	},
	{
		path: 'engagement/:profileId',
		component: Engagement
	},
	{
		path: 'engagement/:profileId/:eventId',
		component: EventDetail
	},
	{
		path: 'engagement/:profileId/:eventId/:messageId',
		component: MessageDetail
	}
]
